



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import Button from '@/apps/open/components/Button'

@Component({
  components: {
    Button
  }
})
export default class EditIpWhitelistDialogBody extends Vue {
  @Prop()
  value!: string[]

  @Prop()
  onCancel!: Function

  @Prop()
  onOk!: Function

  ipList = this.value.join('\n')
  errorMsg = ''
  invalidIpList: string[] = []

  @Watch('ipList')
  onIpListChange () {
    this.errorMsg = ''
  }

  submit () {
    this.validator()
    if (this.errorMsg) {
      return
    }
    this.onOk(this.ipList)
  }

  validator () {
    this.invalidIpList.length = 0

    if (!this.ipList.trim()) {
      this.errorMsg = '请输入IP'
      return
    }

    this.ipList.split('\n').forEach((i: string) => {
      const ip = i.trim()
      const ipRegexp = /^(([01]?\d?\d|2[0-4]\d|25[0-5])\.){3}([01]?\d?\d|2[0-4]\d|25[0-5])(\/(\d{1}|[0-2]{1}\d{1}|3[0-2]))?$/
      if (ip !== '' && !ipRegexp.test(ip)) {
        this.invalidIpList.push(ip)
      }
    })

    if (this.invalidIpList.length) {
      this.errorMsg = '含有不合法的IP地址，多个IP地址请用回车隔开'
    }
  }
}
